import { createAction } from 'redux-actions'

const defaultPrefix = 'JOURNALISTS/'
let prefix = defaultPrefix

// DATA
prefix = `${defaultPrefix}DATA/`

export const importJournalistsStart = createAction(`${prefix}IMPORT_JOURNALISTS_START`)
export const importJournalistsSuccess = createAction(`${prefix}IMPORT_JOURNALISTS_SUCCESS`)
export const importJournalistsError = createAction(`${prefix}IMPORT_JOURNALISTS_ERROR`)

export const pageMyContacts = createAction(`${prefix}PAGE_MY_CONTACTS`)
export const pageAllContacts = createAction(`${prefix}PAGE_ALL_CONTACTS`)

export const importJournalistsToListStart = createAction(`${prefix}IMPORT_JOURNALISTS_TO_LIST_START`)
export const importJournalistsToListSuccess = createAction(`${prefix}IMPORT_JOURNALISTS_TO_LIST_SUCCESS`)
export const importJournalistsToListError = createAction(`${prefix}IMPORT_JOURNALISTS_TO_LIST_ERROR`)

export const loadJournalistNewsStart = createAction(`${prefix}LOAD_JOURNALIST_NEWS_START`)
export const loadJournalistNewsSuccess = createAction(`${prefix}LOAD_JOURNALIST_NEWS_SUCCESS`)
export const loadJournalistNewsError = createAction(`${prefix}LOAD_JOURNALIST_NEWS_ERROR`)

export const searchDistributionListsStart = createAction(`${prefix}SEARCH_DISTRIBUTION_LISTS_START`)
export const searchDistributionListsSuccess = createAction(`${prefix}SEARCH_DISTRIBUTION_LISTS_SUCCESS`)
export const searchDistributionListsError = createAction(`${prefix}SEARCH_DISTRIBUTION_LISTS_ERROR`)

export const fetchPublicationsStart = createAction(`${prefix}FETCH_PUBLICATIONS_START`)
export const fetchPublicationsSuccess = createAction(`${prefix}FETCH_PUBLICATIONS_SUCCESS`)
export const fetchPublicationsError = createAction(`${prefix}FETCH_PUBLICATIONS_ERROR`)

export const toggleAllJournalistsStart = createAction(`${prefix}TOGGLE_ALL_JOURNALISTS_START`)
export const toggleAllJournalistsSuccess = createAction(`${prefix}TOGGLE_ALL_JOURNALISTS_SUCCESS`)
export const toggleAllJournalistsError = createAction(`${prefix}TOGGLE_ALL_JOURNALISTS_ERROR`)

export const searchJobTitlesStart = createAction(`${prefix}SEARCH_JOB_TITLES_START`)
export const searchJobTitlesSuccess = createAction(`${prefix}SEARCH_JOB_TITLES_SUCCESS`)
export const searchJobTitlesError = createAction(`${prefix}SEARCH_JOB_TITLES_ERROR`)

// UI
prefix = `${defaultPrefix}UI/`

export const setSimple = createAction(`${prefix}SET_SIMPLE`)
export const setAdvanced = createAction(`${prefix}SET_ADVANCED`)

export const openJournalistDetails = createAction(`${prefix}OPEN_JOURNALIST_DETAILS`)
export const closeJournalistDetails = createAction(`${prefix}CLOSE_JOURNALIST_DETAILS`)

export const toggleJournalistId = createAction(`${prefix}TOGGLE_JOURNALIST_ID`)
export const selectJournalistIds = createAction(`${prefix}SELECT_JOURNALISTS_IDS`)
export const resetJournalistIds = createAction(`${prefix}RESET_JOURNALIST_IDS`)

export const openDistributionListsDialog = createAction(`${prefix}OPEN_DISTRIBUTION_LISTS_DIALOG`)
export const closeDistributionListsDialog = createAction(`${prefix}CLOSE_DISTRIBUTION_LISTS_DIALOG`)

export const setDistributionListsDialogJoIds = createAction(`${prefix}SET_DISTRIBUTION_LISTS_DIALOG_JO_IDS`)
export const setSelectedDistributionLists = createAction(`${prefix}SET_SELECTED_DISTRIBUTION_LISTS`)
export const setNewDistributionLists = createAction(`${prefix}SET_NEW_DISTRIBUTION_LISTS`)

export const openIptcMediaTopicsDialog = createAction(`${prefix}OPEN_IPTC_MEDIA_TOPICS_DIALOG`)
export const closeIptcMediaTopicsDialog = createAction(`${prefix}CLOSE_IPTC_MEDIA_TOPICS_DIALOG`)
export const setIptcMediaTopics = createAction(`${prefix}SET_IPTC_MEDIA_TOPICS`)

export const selectAllJournalists = createAction(`${prefix}SELECT_ALL_JOURNALISTS`)
export const deselectAllJournalists = createAction(`${prefix}DESELECT_ALL_JOURNALISTS`)
export const setSelectedJournalistIds = createAction(`${prefix}SET_SELECTED_JOURNALIST_IDS`)

export const setAnimateSearchBtn = createAction(`${prefix}SET_ANIMATE_SEARCH_BTN`)
export const setShowTopicHelperText = createAction(`${prefix}SET_SHOW_TOPIC_HELPER_TEXT`)

// PAGINATION
prefix = `${defaultPrefix}PAGINATION/`

export const setPagination = createAction(`${prefix}SET_PAGINATION`)
export const setMyContactsPagination = createAction(`${prefix}/MY_CONTACTS/SET_PAGINATION`)

// SEARCH
prefix = `${defaultPrefix}SEARCH/`

export const simpleSearchStart = createAction(`${prefix}SIMPLE_SEARCH_START`)

export const searchJournalistsStart = createAction(`${prefix}SEARCH_JOURNALISTS_START`)
export const searchJournalistsSuccess = createAction(`${prefix}SEARCH_JOURNALISTS_SUCCESS`)
export const searchJournalistsError = createAction(`${prefix}SEARCH_JOURNALISTS_ERROR`)

export const setQuery = createAction(`${prefix}SET_QUERY`)
export const setFilter = createAction(`${prefix}SET_FILTER`)
export const setIptcMediaTopicFilter = createAction(`${prefix}SET_IPTC_MEDIA_TOPIC_FILTER`)

export const clearFilters = createAction(`${prefix}CLEAR_FILTERS`)
